import { Classifier } from '@dealstack/frontend/app/pages/Project/DealSettings/Classifiers/types';
import { DealClassifierTct } from '@dealstack/shared/lib/generated';

export function getClassificationParent(
	classifier: Classifier,
	availableClassifiers: DealClassifierTct[] = []
): DealClassifierTct | null {
	if (!classifier.classifierParentId) {
		return null;
	}

	// Helper function to recursively search through classifiers and their children
	const findParentRecursively = (classifiers: DealClassifierTct[]): DealClassifierTct | null => {
		for (const availableClassifier of classifiers) {
			// check if this classifier is the parent
			if (availableClassifier.classifierId === classifier.classifierParentId) {
				return availableClassifier;
			}

			// recursively search in children
			if (availableClassifier.children && availableClassifier.children.length > 0) {
				const foundInChildren = findParentRecursively(availableClassifier.children);
				if (foundInChildren) {
					return foundInChildren;
				}
			}
		}
		return null;
	};

	return findParentRecursively(availableClassifiers);
}

export function getAllClassifiersFilter(dealId: string) {
	return {
		filters: {
			filter: {
				getAll: true,
			},
			sortBy: {
				key: 'name',
				desc: false,
			},
		},
		dealId,
	};
}
